<template>
    <Transition name="fade">
        <div v-if="show" class="thanks-container">
            <div class="thanks-content">
                <div class="thanks-message">Thanks for playing</div>
                <div class="site-name">at {{ siteName }}</div>
                <div class="subtext">Network Trivia broadcast will resume shortly!</div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import {systemInfo} from "@/systemInfo.js";

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    siteName: {
        type: String,
        default: () => systemInfo.handshakeInfo.siteName || 'Your Buzztime Venue'
    }
});
</script>

<style scoped>
.thanks-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 103;
    /*pointer-events: none;*/
    transition: var(--transition-normal);
}

.thanks-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-transform: uppercase;
    text-shadow: var(--shadow-md);
    color: var(--color-text);
    font-size: var(--font-size-title);
}

.thanks-message {
    position: fixed;
    top: calc(var(--spacing-xl) * 2.5);
}

.site-name {
    position: fixed;
    bottom: calc(var(--spacing-xl) * 2.5);
}

.subtext {
    position: fixed;
    bottom: calc(var(--spacing-xl) * 1);
    font-size: var(--font-size-md);
}

/* Transition classes */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
